<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half"><span class="bold">JOACHIM PEIPER AND THE NAZI ATROCITIES OF 1944</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?8017c11c